import {
  Card,
  Grid,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { CardSection, CardSubSection, Chip, useIsMobile } from '@side/pantry';
import { AccountSettingsTeamPermissionsHeader } from './AccountSettingsTeamPermissionsHeader';

const SkeletonRow = () => (
  <TableRow sx={{ height: '68px' }}>
    <TableCell>
      <Skeleton variant="rectangular" width="100%" />
    </TableCell>
    {/* Role */}
    <TableCell>
      <Skeleton variant="rectangular" width="100%" />
    </TableCell>
    {/* Status */}
    <TableCell>
      <Skeleton variant="rectangular" width="100%" />
    </TableCell>
    {/* Create as You */}
    <TableCell>
      <Skeleton variant="rectangular" width="100%" />
    </TableCell>
    {/* Edit Your Transactions */}
    <TableCell>
      <Skeleton variant="rectangular" width="100%" />
    </TableCell>
  </TableRow>
);

const LoadingCardTitleSkeleton = () => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Skeleton height={19} width={137} />
      <Skeleton height={19} width={55} />
    </Stack>
  );
};

const LoadingMobileCard = () => {
  return (
    <CardSection
      sx={{
        '& .MuiBox-root': {
          width: '100%',
        },
        '& .MuiTypography-root': {
          width: '100%',
        },
      }}
      cardTitle={<LoadingCardTitleSkeleton />}
    >
      <CardSubSection>
        <Grid container spacing={2}>
          <Grid size={6}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Grid>
          <Grid size={6}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Grid>
        </Grid>
      </CardSubSection>
    </CardSection>
  );
};

export const AccountSettingsTeamPermissionsSkeleton = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Stack sx={{ flexDirection: 'column', gap: 2, p: 2, width: '100%' }}>
        <AccountSettingsTeamPermissionsHeader />

        <Skeleton variant="rectangular" width="100%" height={40} />
        <Stack sx={{ flexDirection: 'row', gap: 2 }}>
          <Skeleton variant="rectangular" width="60%" height={40} />
          <Skeleton variant="rectangular" width="40%" height={40} />
        </Stack>

        <LoadingMobileCard />
        <LoadingMobileCard />
        <LoadingMobileCard />
      </Stack>
    );
  }

  return (
    <>
      {/* 1. Skeleton for Header Section */}
      <AccountSettingsTeamPermissionsHeader />
      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          px: isMobile ? 2 : 3,
          gap: isMobile ? 2 : 3,
        }}
      >
        <Skeleton variant="rectangular" width={566} height={40} />
        <Stack sx={{ my: 'auto' }}>
          <Skeleton variant="rectangular" width={116} height={40} />
        </Stack>
      </Stack>
      <Stack
        direction="row"
        sx={[
          {
            gap: 1,
            flexWrap: isMobile ? 'nowrap' : 'wrap',
          },
          isMobile
            ? { overflowX: 'auto' }
            : { mt: 3, mb: 2, px: isMobile ? 2 : 3 },
        ]}
      >
        <Chip
          key="active"
          variant="outlined"
          label="Active"
          // Set but empty so that button appears
          onDelete={() => undefined}
        />
      </Stack>
      {/* 2. Skeleton for DataGrid Section */}
      <Stack
        sx={{
          gap: 2,
          px: 3,
          pb: 3,
        }}
      >
        <TableContainer component={Card}>
          <Table aria-label="team permissions skeleton">
            <TableHead>
              <TableRow sx={{ height: '38px' }}>
                <TableCell sx={{ p: 1, pl: 3 }}>
                  <Typography variant="subtitle2">Team Member</Typography>
                </TableCell>
                <TableCell sx={{ p: 1, pl: 3 }}>
                  <Typography variant="subtitle2">Role</Typography>
                </TableCell>
                <TableCell sx={{ p: 1, pl: 3 }}>
                  <Typography variant="subtitle2">Status</Typography>
                </TableCell>
                <TableCell sx={{ p: 1, width: 176 }}>
                  <Typography variant="subtitle2">Create as You</Typography>
                </TableCell>
                <TableCell sx={{ p: 1, width: 176 }}>
                  <Typography variant="subtitle2">
                    Edit your transaction
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
              <SkeletonRow />
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </>
  );
};
